import React from 'react';
import tw from 'twin.macro';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { SubHeader } from '@teetsh/app/src/components/SubHeader';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { GlobalMessage } from 'types/cms';
import { useState } from 'react';
import Cookies from 'js-cookie';
import ButtonExternal from 'components/Buttons/ExternalLink';
import { GlobalMessageIconComponent } from './GlobalMessageIconComponent';
import { trackEvent } from 'queries/user/track';

function GlobalMessageBannerBody(props: { globalMessage: GlobalMessage }) {
  const { globalMessage } = props;
  const messageId = globalMessage.id;
  const { content, intent, icon, cta } = globalMessage;

  const savedVisibility: string | undefined = Cookies.get(
    `message-visibility-${messageId}`,
  );
  const [isVisible, setIsVisible] = useState(savedVisibility !== 'hidden');

  if (!isVisible) {
    return null;
  }

  const handleClose = () => {
    setIsVisible(false);
    Cookies.set(`message-visibility-${messageId}`, 'hidden', { expires: 7 }); // Expires in 7 days
  };

  return (
    <SubHeader
      css={[
        intent === 'outage' && tw`bg-danger-intense`,
        intent === 'marketing' && tw`bg-brand-intense`,
        intent === 'warning' && tw`bg-warning-intense`,
      ]}
    >
      <div tw="flex justify-center items-center text-white text-base">
        <div tw="font-semibold flex justify-between text-base text-white w-full">
          <div tw="flex flex-wrap items-center justify-center mx-auto gap-y-2">
            <div tw="text-center text-pretty">
              {icon && (
                <span tw="mr-1">
                  <GlobalMessageIconComponent icon={icon} />
                </span>
              )}
              {content}
            </div>
            {cta && (
              <ButtonExternal
                intent="empty"
                href={cta.buttonLink}
                onClick={() =>
                  trackEvent('GlobalMessageBanner:clickCta', {
                    buttonTitle: cta.buttonTitle,
                    buttonLink: cta.buttonLink,
                  })
                }
                tw="ml-3 shadow-md rounded-full bg-gradient-to-r to-amber-500 from-indigo-500 hover:to-amber-600 hover:from-indigo-600 px-4 py-0.5 text-white font-semibold transition border-0 ring-1 ring-inset"
              >
                {cta.buttonTitle}
                <ArrowTopRightOnSquareIcon tw="ml-1 h-4 w-4 inline-block" />
              </ButtonExternal>
            )}
          </div>
          {intent === 'marketing' && (
            <div tw="ml-3 flex">
              <button
                type="button"
                aria-label="Fermer le message"
                tw="text-white transition duration-200 ease-in-out hover:scale-150"
                onClick={handleClose}
              >
                <XMarkIcon tw="h-6 w-6 items-center" />
              </button>
            </div>
          )}
        </div>
      </div>
    </SubHeader>
  );
}

interface Props {
  globalMessage?: GlobalMessage;
}

export function GlobalMessageBanner(props: Props) {
  const { globalMessage } = props;
  if (!globalMessage) {
    return null;
  }
  return <GlobalMessageBannerBody globalMessage={globalMessage} />;
}
